import { MeterpointGuideCta } from 'components/direct-sales/meterpoint-validation/components/MeterpointGuideCta';

export const GuideHelpText = () => {
  return (
    <>
      Please double check your meter reference number. <MeterpointGuideCta />{' '}
      for where to find it
    </>
  );
};
